import { isObject } from "lodash";
import { ErrorPage } from "./ErrorPage";
import React from "react";

interface IErrorBoundaryProps {
  children?: React.ReactNode;
}

interface IErrorBoundaryState {
  hasError: boolean;
  error?: any;
  errorInfo?: any;
}

export class ErrorBoundary extends React.Component<
  IErrorBoundaryProps,
  IErrorBoundaryState
> {
  constructor(props: Readonly<IErrorBoundaryProps>) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(): { hasError: boolean } {
    // show error page
    return { hasError: true };
  }

  public componentDidCatch(error: any, errorInfo: any) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    const { hasError, error } = this.state;

    if (hasError) {
      const parsedError = isObject(error)
        ? (error as any).data ?? error
        : error;

      return (
        <ErrorPage
          className="avis-error-boundary"
          title="Kļūda!"
          content="Mēģiniet pārlādēt lapu."
          info={parsedError?.toString()}
          stackTrace={error?.stack}
        />
      );
    }

    return this.props.children;
  }
}
